module.exports = __webpack_public_path__ + "media/img/about/bg-cta-5c7d618561477f0108f204c229e2baa6.png";